import React from 'react';
import { TextField } from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { getSentence } from '../translations';

const SpeakerEditor = ({ 
  speaker, 
  speakers, 
  onSpeakerChange,
  disabled = false 
}) => {
  const filter = createFilterOptions();

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // Prevent the default Enter behavior
      event.preventDefault();
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      const currentValue = event.target.value;
      
      if (currentValue) {
        // Handle new speaker case
        if (!speakers.includes(currentValue)) {
          onSpeakerChange(currentValue);
        } else {
          // Handle existing speaker case
          onSpeakerChange(currentValue);
        }
      }
    }
  };

  return (
    <Autocomplete
      value={speaker}
      onChange={(event, newSpeaker) => {
        // Only handle non-Enter triggered changes
        if (!event || event.key !== 'Enter') {
          onSpeakerChange(newSpeaker);
        }
      }}
      disabled={disabled}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        if (params.inputValue !== '' && !speakers.includes(params.inputValue)) {
          filtered.unshift({
            inputValue: getSentence(76) + `${params.inputValue}`,
            originalValue: params.inputValue,
          });
        }
        return filtered;
      }}
      options={speakers}
      getOptionLabel={(option) => {
        // e.g. value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
        return option.title || '';
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      sx={{ width: { xs: 200, sm: 200, md: 300, lg: 300, xl: 300 } }}
      freeSolo
      size="small"
      renderInput={(params) => (
        <TextField 
          {...params} 
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
      )}
    />
  );
};

SpeakerEditor.displayName = 'SpeakerEditor';

export default SpeakerEditor; 